import { makeAnalyticsAction, } from '../analytics/analytics-utils.js';
//TODO: KIT-2859
export const logNavigateForward = () => makeAnalyticsAction('history/analytics/forward', (client) => client.makeSearchEvent('historyForward') // TODO: Need to create this event natively in coveo.analytics to remove cast
);
//TODO: KIT-2859
export const logNavigateBackward = () => makeAnalyticsAction('history/analytics/backward', (client) => client.makeSearchEvent('historyBackward') // TODO: Need to create this event natively in coveo.analytics to remove cast
);
//TODO: KIT-2859
export const logNoResultsBack = () => makeAnalyticsAction('history/analytics/noresultsback', (client) => client.makeNoResultsBack());
// --------------------- KIT-2859 : Everything above this will get deleted ! :) ---------------------
